<template>
	<AppScreen class="home-screen" :scrollable="false">
		<NGPFLogo />
		<div class="content">
			<div class="title-logo"></div>
			<p class="intro wysiwyg-content">{{ ui.content }}</p>
			<MarqueeButton :action="startIntro">{{ ui.button_text }}</MarqueeButton>
		</div>
	</AppScreen>
</template>

<script>
import { mapState } from "vuex";
import AppScreen from '@/components/partials/AppScreen';
import MarqueeButton from '@/components/base/MarqueeButton';
import NGPFLogo from '@/components/base/NGPFLogo';

export default {
	name: 'Home',
	components: {
		AppScreen,
		MarqueeButton,
		NGPFLogo,
	},
	computed: {
		...mapState({
			ui: (state) => state.global.api.data.ui.homepage,
		}),
	},
	methods: {
		startIntro() {
			this.$router.push('/intro');
			this.$store.dispatch("sound/unmute");
			this.$store.dispatch("sound/fx/play", { id: "audience_track" });
			this.$store.dispatch("global/analytics/trackPageView", { dp: "/tutorial" });
		},
	},
};
</script>

<style lang="scss" scoped>
	.home-screen {
		@include swirl-background;
		display: flex;
		flex-direction: column;
		justify-content: center;
		align-items: center;
		padding: 0 20px;
	}

	.content {
		display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
		text-align: center;
		max-width: 500px;

		@include desktop {
			max-width: 100%;
		}
	}

	.title-logo {
		@include drop-shadow;
		margin: 20px 0;
		width: 300px;
		height: 267.5px;
		background-image: url('~@/assets/images/bummer-logo-mobile.png');
		background-size: cover;
		background-repeat: no-repeat;
		animation: toggle-logo-mobile infinite 2s steps(2);

		@include tablet {
			width: 500px;
			height: 445.5px;
			animation: toggle-logo-tablet infinite 2s steps(2);
		}

		@include desktop {
			background-image: url('~@/assets/images/bummer-logo-desktop.png');
			background-size: cover;
			background-repeat: no-repeat;
			animation: toggle-logo-desktop infinite 2s steps(2);
			width: 800px;
			height: 320px;
		}
	}

	@keyframes toggle-logo-mobile {
		0% { background-position: 0px 0px; }
		100% { background-position: 0px -534px; }
	}

	@keyframes toggle-logo-tablet {
		0% { background-position: 0px 0px; }
		100% { background-position: 0px -890px; }
	}

	@keyframes toggle-logo-desktop {
		0% { background-position: 0px 0px; }
		100% { background-position: 0px -650.5px; }
	}

	.marquee-btn { margin-bottom: 0; }
</style>
